module.exports = __webpack_public_path__ + "img/e_2_16_r.1778d275.png";